/**
 * Modèle PlayerNotification - Identique à Flutter
 */

export interface PlayerNotification {
  title: string;
  description?: string;
  additionalInfo?: string;
  isCheat: boolean;
}

export const PlayerNotificationFromJson = (json: any): PlayerNotification => {
  if (!json || typeof json.title !== 'string') {
    throw new Error('Invalid PlayerNotification JSON: missing title');
  }

  return {
    title: json.title,
    description: json.description,
    additionalInfo: json.additionalInfo,
    isCheat: json.isCheat === true,
  };
};
